import React from 'react';
import { motion } from 'framer-motion';
import './about.css';

const peoImg = [
  
  {
    title: 'Rid - Product Designer',
    img:'https://i.bmp.ovh/imgs/2022/05/03/ce18a6589023ed2a.png',
  },
  {
    title: 'Jack - Software Engineer',
    img: 'https://i.bmp.ovh/imgs/2022/05/03/8e5f00d264e2e24f.png',
  },
  {
    title: 'Linda - Marketing Specialist',
    img: 'https://i.bmp.ovh/imgs/2022/05/03/2448ad56dbe881a2.png',
  },
]

  const About = () => {
   
    return (
      <div className='duf__aboutus' id='aboutus'>
        <div className='about__container'>
        <h2 className='head-text'>About Us</h2>
  
        <div className='app__profiles'>
       
          {peoImg.map((peoImg, index) => (
            <motion.div
              whileInView={{ opacity: 1 }}
              whileHover={{ scale: 1.1 }}
              transition={{ duration: 0.5, type: 'tween' }}
              className="app__profile-item"
              key={index}
            >
              <img src={peoImg.img} alt={peoImg.title} />
             
              {/* <img src={pic1} alt={peoImg.title} /> */}
              <p className="intro-text" >{peoImg.title}</p>
            </motion.div> 
          )
          )}
        </div>
        </div>
      </div>
    )
  }
export default About;